'use client';
import { useEffect, useState } from 'react';

const copy = {
  en: ['Something went wrong', 'Your saved transcripts are still available. Try loading this page again.', 'Try again'],
  de: ['Die Seite konnte nicht angezeigt werden', 'Deine gespeicherten Transkripte sind weiterhin verfügbar. Lade die Seite erneut.', 'Erneut versuchen'],
  fr: ['Impossible d’afficher la page', 'Vos transcriptions enregistrées sont toujours disponibles. Rechargez cette page.', 'Réessayer'],
};

export default function ErrorRecovery({ error, reset }) {
  const [locale, setLocale] = useState('en');
  useEffect(() => {
    setLocale(document.documentElement.lang?.split('-')[0] || 'en');
    window.instantTranscriberDiagnostics?.reportRuntimeError('react_render_error', error);
  }, [error]);
  const [title, body, retry] = copy[locale] || copy.en;
  const retryPage = () => {
    reset();
    // A click is an attempt, not proof of recovery. Wait until the replacement
    // page has committed without another error fallback before recording it.
    let checks = 0, healthyChecks = 0;
    const timer = setInterval(() => {
      healthyChecks = document.querySelector('[data-it-runtime-recovery]') ? 0 : healthyChecks + 1;
      if (healthyChecks >= 2) {
        clearInterval(timer);
        window.instantTranscriberDiagnostics?.reportRuntimeRecovery?.(error);
      } else if (++checks >= 50) clearInterval(timer);
    }, 100);
  };
  return <main data-it-runtime-recovery style={{ maxWidth: 560, margin: '12vh auto', padding: 24, textAlign: 'center' }} role="alert">
    <h1>{title}</h1>
    <p>{body}</p>
    <button type="button" onClick={retryPage}>{retry}</button>
  </main>;
}
